import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { EventsService } from "../../events.service";
import { withLatestFrom, switchMap, of, map, exhaustMap } from "rxjs";
import { EventActions, EventApiActions } from "../actions/events.actions";
import { selectAllEvents, selectAllUpcomingEventsFlag, selectEvent, selectTotalEvents } from "../selectors/events.selectors";
import { EventComplete } from "../../models/events/event-complete.model";
import { concatLatestFrom } from '@ngrx/operators'

@Injectable()
export class EventsEffects {
    private action$ = inject(Actions);
    private service = inject(EventsService);
    private store = inject(Store);

    loadEventsBySystem$ = createEffect(() => {
        return this.action$.pipe(
            ofType(EventActions.loadAllEventsBySystem),
            concatLatestFrom(() => [
                this.store.select(selectTotalEvents),
                this.store.select(selectAllUpcomingEventsFlag)
            ]),
            switchMap(([action,data]) => {
                if (data[0] > 0 && data[1]){
                    return of();
                }
                else{
                    return this.service.getUpcomingEvents(action.systemRef).pipe(
                        map(data => EventApiActions.fetchAllEventsBySystem({ events:data as EventComplete[], systemRef: action.systemRef}))
                    )
                }
            })
        )
    })

    loadUpcomingEvents$ = createEffect(() => {
        return this.action$.pipe(
            ofType(EventActions.loadAllUpcomingEvents),
            concatLatestFrom(() => [
                this.store.select(selectTotalEvents),
                this.store.select(selectAllUpcomingEventsFlag)
            ]),
            switchMap(([action,data]) => {
                if (data[0] > 0 && data[1]){
                    return of();
                }
                else {
                    return this.service.getUpcomingEvents().pipe(
                        map(data => EventApiActions.fetchAllUpcomingEvents({ events:data as EventComplete[]}))
                    )
                }
            })
        )
    })

    loadSingleEvent$ = createEffect(() => {
        return this.action$.pipe(
            ofType(EventActions.loadSingleEvent),
            concatLatestFrom(action => this.store.select(selectEvent(action.eventRef))),
            switchMap(([action, data]) => {
                if (data && !action.refresh){
                    return of();
                }
                else {
                    return this.service.getEvent(action.eventRef).pipe(
                        map(data => EventApiActions.fetchSingleEvent({ event: data as EventComplete}))
                    )
                }
            })
        )
    })

    getPublicAttendees$ = createEffect(() => {
        return this.action$.pipe(
            ofType(EventActions.getAttendees),
            exhaustMap(action => {
                return this.service.getAttendees(action.eventID).pipe(
                    map(data => EventApiActions.fetchedAttendees({ update: {
                        id: action.eventID,
                        changes: {
                            eventAttendees: data 
                        }
                    } }))
                )
            })
        )
    })
}